<template>
    <div class="login-wrapper">
		  <page-header />
        <div class="top flex-center">
            <div class="flex-bt w1200">
                <a href="/" class="logo">
      
                </a>
       <!--         <div class="right flex-end">
                    <div class="items">
                        <i class="iconfont">&#xe634;</i>
                        {{$t('Complete variety')}}
                    </div>
                    <div class="items">
                        <i class="iconfont">&#xe8c8;</i>
                       {{$t('Low price')}}
                    </div>
                    <div class="items">
                        <i class="iconfont">&#xe888;</i>
                       {{$t('Authentic Marketing')}}
                    </div>
                </div> -->
            </div>
        </div>
        <div v-if="loginMethod=='mobile'" class="bottom">
            <div class="wrapper">
                <div class="title">{{$t('Quick registration')}}</div>
               <el-form ref="form" :model="form">
                   <el-input :placeholder="$t('Please input phone')" v-model="form.mobile" class="input-with-select">
                     
                   </el-input>
                   <el-input :placeholder="$t('Please input email')" v-model="form.email" class="input-with-select">
                     
                    </el-input>
                    <el-input  type="password" :placeholder="$t('Please input password')" v-model="form.password" class="input-with-select">  </el-input>
                    <el-input type="password" :placeholder="$t('Please input password')" v-model="form.repassword" class="input-with-select">
                     
                   </el-input>
                  
               </el-form>
                <div style="background-color:#409eff !important" class="signIn bg-color" @click="regSubmit">  {{$t('Fast Reg')}}</div>
                  <div @click="loginMethod='password'" class="fastLogin font-color">{{$t('PWD login')}}</div>  
            </div>
        </div>
        <div v-if="loginMethod=='password'" class="bottom">
            <div class="wrapper">
                <div class="title"> {{$t('PWD login')}}</div>
                <el-form ref="form" :model="form">
                    <el-input :placeholder="$t('Please input phone')" v-model="form.mobile" class="input-with-select">
                      
                    </el-input>
                     <el-input type="password" :placeholder="$t('Please input password')" v-model="form.password" class="input-with-select">
                      
                    </el-input>
                   
                </el-form>
                <div class="signIn bg-color" @click="loginSubmit">{{$t('PWD login')}}</div>
				<div @click="loginMethod='forgetpassword'" >{{$t('Forgot password')}}</div>
                <div @click="loginMethod='mobile'" style="color:#409eff" class="fastLogin">{{$t('Fast Reg')}}</div> 

                 <div v-if="uniacid !== 20" @click="logInWithFacebook" style="color:#409eff" class="fastLogin">Sign in with Facebook</div>
                <!--
                <div v-if="facebooklogin"  style="color:#409eff" class="fastLogin"> 
                    
                    
                <fb-signin-button
			         :params="fbSignInParams"
			         @success="onSignInSuccess"
			         @error="onSignInError">
			    {{$t('Sign in with Facebook')}}
			 </fb-signin-button

             <button class="button" @click="logInWithFacebook"> Sign in with Facebook</button>


             <button class="button" @click="logInWithFB"> Login with Facebook 2</button>
            
            </div>  -->
				
            </div>
			
        </div>

        <div v-if="loginMethod=='forgetpassword'" class="bottom">
            <div class="wrapper">
                <div class="title">{{$t('')}}</div>
                <el-form ref="forgetpasswordform" @submit.prevent="forgetpwd">
                    <el-input :placeholder="$t('Please input email')" v-model="forgetpasswordform.email" class="input-with-select">
                      
                    </el-input>
                    <!--
                    <input type="submit" value="確定" class="signIn bg-color" style="border: none">-->
                </el-form>
                
                <div @click="forgetpwd" class="signIn bg-color">{{$t('Confirm')}}</div>

				<div @click="loginMethod='password'" class="fastLogin font-color">{{$t('PWD login')}}</div>  
            </div>
			
        </div>
		 
			  
    </div>
</template>
<script>
import emailjs from 'emailjs-com';
import countdown from '../../utils/countdown'
import PageHeader from '../../layout/components/Header'
export default {
    name: 'Login',
	components: {PageHeader},
    data() {
        return {
			webset:[],
            uniacid: parseInt(window.localStorage.getItem('uniacid')),
            //uniacid:20,
			loginMethod:'password',
            address: [
                {text: "香港",value: "852"},
                {text: "澳门",value: "853"},
                {text: "中国大陆",value: "86"},
		    ],
            form: {
                email: '',
                mobile: '',
                diqu: '852',
                password: '',
                repassword: '',
                code: '',
                action: 'login'
            },
            forgetpasswordform: {
                email: '',
                pw: ""
            },
            sendCodeText: '發送驗證碼',
			facebooklogin:false,
            fbSignInParams: {
                scope: 'email',
                return_scopes: true
            },
            locale: window.localStorage.getItem('locale') || this.$i18n.locale,
        }
    },
	created() {
		var ss = window.localStorage.getItem('webinfo');
		var ssarray = JSON.parse(ss)
		 
		this.webset =  ssarray
		this.uniacid = ssarray['ucid']
        //this.uniacid = 20
		if(ssarray['openfacebook']>0){
			this.facebooklogin = true 
		}
		this.form.uniacid = this.uniacid
        this.forgetpasswordform.uniacid = this.uniacid


        console.log("ss")
        console.log(ss)
		
		
	},
    methods: {
        async logInWithFB() {
            console.log("login in with FB")
            window.FB.getLoginStatus(function(response) {
                console.log(response);
            });

            window.FB.api('/me', function(response) {
                console.log(JSON.stringify(response));
            });
        },
        async logInWithFacebook() {
            const initSuccess = await this.initFacebook();
            if (!initSuccess) return;
            let fb_user_id = ''
            let fb_name = ''
            let fb_token = '';
            await window.FB.login((response) => {
                if (response.authResponse) {
                    window.FB.api('/me', (response2) => {
                        console.log(JSON.stringify(response2));
                        fb_user_id = response.authResponse.userID;
                        fb_name = response2.name;
                        fb_token = response.authResponse.accessToken;

                        console.log(fb_user_id + ", " + fb_name + ", " + fb_token);
                        this.$message({ message: '您好' + JSON.stringify(fb_name) + '，登入Facebook成功',type: 'success'});
                        
                        let fdata= {
                            userid: fb_user_id
                        }

                        window.localStorage.setItem('fb_user_id', fb_user_id);
                        window.localStorage.setItem('fb_name', fb_name);
					 
                        this._loginFB(fdata);

                        /*
                        const data = {
                            "user_id": response.authResponse.userID,
                            "token": response.authResponse.accessToken
                        }
                        window.localStorage.setItem('user_id', response.authResponse.userID);
                        window.localStorage.setItem('login@token', response.authResponse.accessToken)
                        document.cookie = 'PHPSESSID=' + response.authResponse.accessToken;
                        //this.getUserInfo()
                        this.$store.commit('saveUserInfo',data);
                        window.location.hash = '/';*/

                                    
                    });

                   // const data = {
                    //    "user_id": response.authResponse.userID,
                    //    "token": response.authResponse.accessToken
                    //}
                    //this._loginSuccessCallback(data, true)
                } else {
                    this.$message({ message: 'User cancelled login or did not fully authorize.',type: 'warning'});
                }
            });

            

            /*
            window.localStorage.setItem('user_id', fb_user_id);
            window.localStorage.setItem('login@token', fb_token)
            document.cookie = 'PHPSESSID=' + fb_token;
            this.getUserInfo()
            this.$store.commit('saveUserInfo',data);

            window.location.hash = '/';*/

            return false;
        },
        async initFacebook() {
            var fblist = [
                {
                    "uniacid": 15, //Dr. Alex Au
                    "api": "343963538225568"
                },
                {
                    "uniacid": 17, //Dr.Newmann
                    "api": "606398301706754"
                },
                {
                    "uniacid": 19, //ACE
                    "api": "2012362119109138"
                },
                {
                    "uniacid": 22, //Ho Chun
                    "api": "1019123899114733"
                },
                {
                    "uniacid": 20, // Unique Fencing
                    "api": "674458627910520"
                },
                {
                    "uniacid": 24, // SK Easy
                    "api": "3505494359675361"
                }
            ];
            let data = fblist.find(item => item.uniacid === this.uniacid);
            if (!data) {
                this.$message({ message: 'Facebook login is not configured for this site.', type: 'warning' });
                return false;
            }
            let fbApi = data.api;

            //console.log("fbApi: " + fbApi)

            window.fbAsyncInit = function() {
                window.FB.init({
                    appId: fbApi, //You will need to change this
                    cookie: true, // This is important, it's not enabled by default
                    version: "v17.0"
                });
            };
            return true;
        },
        async loadFacebookSDK(d, s, id) {
            var js,
            fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        },

        // 发送驗證碼
        async sendMobileCode() {
            console.log(this.$http)
            if (!this.form.mobile) return this.$message({ message: '請輸入手機號',type: 'warning'});
            const res = await this.$http.post('/validate/sendMobileCode', this.form)
            if (res.code !== 0) return this.$message.error(res.message)
            let data = res.data
            this.form.code = data.code
            countdown.start(data.timer, (d, s) => {
                this.sendCodeText = Number(s).toFixed(0) + 's'
            }, () => {
                this.sendCodeText = '驗證碼'
            })
        },
        // 手机号登录
        async loginSubmit() {
            if (!this.form.mobile) return this.$message({ message: '請輸入手機號', type: 'error' });
            if (this.loginMethod == 'password' && !this.form.password) return this._showToast('請輸入密碼');
            if (this.loginMethod == 'mobile' && !this.form.code) return this.$message({ message: '請輸入驗證碼', type: 'warning' });

            const api = '/login' + (this.loginMethod == 'mobile' ? '/sms' : '');
            const res = await this.$http.post(api, this.form);
            
            if (res.code !== 0) {
                return this.$message.error(res.message);
            }
            
            window.localStorage.setItem('user_id', res.data.user_id);
            window.localStorage.setItem('username', this.form.mobile); 

            this._loginSuccessCallback(res.data, true);
        }, // 手机号reg
		
async regSubmit() {
    if (!this.form.email) { 
        return this.$message({ message: this.$t('Please enter email'), type: 'error' });
    }
    if (!this.form.mobile) {
        return this.$message({ message: this.$t('Please enter Phone number'), type: 'error' });
    }
    if (this.loginMethod == 'password' && !this.form.password) {
        return this._showToast('請輸入密碼');
    }

    const api = '/user/registerwithemail';
    const res = await this.$http.post(api, this.form);
    
    if (res.code !== 0) {
        this.$message({ message: this.$t(res.message), type: 'error' });
        return;
    }

    this.$message({ message: this.$t(res.message), type: 'success' });
    window.localStorage.setItem('user_id', res.data.user_id);

    // Email 配置
    const emaillist = [
        { uniacid: 43, service: 'service_jybec7h', template: 'template_10eskpq', api: 'FrgSZsm9yHlRrMn0d' },   
        { uniacid: 24, service: 'service_yac630i', template: 'template_l7z8rwo', api: '4wKkS4gd0Zd4UF-Dv' },
    ];
    const data = emaillist.find(item => item.uniacid === this.uniacid);
    if (!data) {
        console.log('No matching email service configuration found.');
        return;
    }

    try {
        // 1. Send Email
        await emailjs.send(data.service, data.template, {
            message: res.message,
            email: this.form.email,
            name: this.form.name
        }, data.api);
     if (this.uniacid == 43){
        // 2. Send SMS（NEW!!）
        const smsRes = await this.$http.post('/user/sendRegSuccessSms', {
            mobile: this.form.mobile,
            name: this.form.name || ''
        });

        if (smsRes.code === 0) {
            this.$message({ message: this.$t('註冊成功！我們已經發送 SMS 驗證碼'), type: 'success' });
        } else {
            this.$message({ message: this.$t('註冊失敗SMS 發送失敗: ') + smsRes.message, type: 'warning' });
        }
    }
    } catch (error) {
        console.log('error', error);
        this.$message({ message: this.$t('register.error'), type: 'error' });
    }
},

		async forgetpwd() {
            const currentEmail = this.forgetpasswordform.email;
            console.log('currentEmail', currentEmail);
            const lastEmail = this.lastEmail || '';
            const lastCallTime = this.lastCallTime || 0;
            const cooldownPeriod = 1 * 60 * 1000; 
            const currentTime = Date.now();
            
            if (currentEmail === lastEmail && currentTime - lastCallTime < cooldownPeriod) {
                const remainingTime = Math.ceil((cooldownPeriod - (currentTime - lastCallTime)) / 1000 / 60);
                this.$confirm(`Please wait ${remainingTime} minute(s) before trying again with the same email.`, {
                    confirmButtonText: 'OK',
                    showCancelButton: false,
                    type: 'info',
                });
                return;
            }

            this.lastCallTime = currentTime;
            this.lastEmail = currentEmail;

            console.log('forgetpwd');
            console.log('uniacid:', this.uniacid);
            var emaillist = [
                {
                    "uniacid": 15, //Alex Au
                    "service": "service_i7iso7c",
                    "template": "template_q3aihip",
                    "api": "V_K_kd8zgoc1TbfFO"
                },
                {
                    "uniacid": 17, //Dr.Newmann
                    "service": "service_bq3vi8c",
                    "template": "template_7umzjba",
                    "api": "9AlvderpThGfNT67k"
                },
                {
                    "uniacid": 19, //ACE
                    "service": "service_vwa1m07",
                    "template": "template_xgz76kk",
                    "api": "H_8c6zkSntZyBRybB"
                },
                {
                    "uniacid": 22, //Ho Chun
                    "service": "service_065c0an",
                    "template": "template_o1j5zei",
                    "api": "Xa1CTNFWE-reiybrI"
                },
                {
                    "uniacid": 20, // Unique Fencing
                    "service": "service_eqgpjwl",
                    "template": "template_w6tkis7",
                    "api": "aeuqp67xbb8BVViRT"
                },
                {
                    "uniacid": 24, // SK Easy
                    "service": "service_yac630i",
                    "template": "template_l7z8rwo",
                    "api": "4wKkS4gd0Zd4UF-Dv"
                },
                {
                    "uniacid": 27, // Trillion
                    "service": "service_dxwctun",
                    "template": "template_23tg4a9",
                    "api": "na9x4syMmIN3PUVmw"
                },
                {
                    "uniacid": 29, // Trillion
                    "service": "service_z6spsoc",
                    "template": "template_prbncii",
                    "api": "hqhqwZZcNHhqIiOLE"
                },
                {
                    "uniacid": 33, // Well Speed
                    "service": "service_zhkh12h",
                    "template": "template_9t1mtcv",
                    "api": "cuOUZQcP3XeoFq8J_"
                },
                {
                    "uniacid": 43, // K520c
                    "service": "service_fi7ac9m",
                    "template": "template_cp0rl96",
                    "api": "FrgSZsm9yHlRrMn0d"
                }
            ];

            let data = emaillist.find(item => item.uniacid === this.uniacid);
            let emailService = data?.service;
            let emailTemplate = data?.template;
            let emailApi = data?.api;
            
            this.forgetpasswordform.pw = this.makeRandomString(8);
            console.log('Email being sent to API:', this.forgetpasswordform.email);
            console.log('Password being sent to API:', this.forgetpasswordform.pw);
            console.log('Uniacid being sent to API:', this.forgetpasswordform.uniacid);
            
            if (!this.forgetpasswordform.email) {
                return this.$message({ message: '請輸入電郵', type: 'warning' });
            }
            
            try {
                console.log('SEND MAIL');
                const api = '/user/resetpw';
                
                const postData = {
                    email: this.forgetpasswordform.email,
                    pw: this.forgetpasswordform.pw,
                    uniacid: this.forgetpasswordform.uniacid
                };
                
                console.log('Data being sent to API:', postData);
                
                const res = await this.$http.post(api, postData);
                
                console.log('API Response:', res);

                if (res.code === 0 && res.data === "ok") {
                    if (data && emailService && emailTemplate && emailApi) {
                        emailjs.send(emailService, emailTemplate, {
                            email: this.forgetpasswordform.email,
                            pw: this.forgetpasswordform.pw
                        }, emailApi)
                        .then((result) => {
                            console.log('SUCCESS!', result.text);
                            this.$confirm('已發出電郵', {
                                confirmButtonText: 'OK',
                                showCancelButton: false,
                                type: 'info',
                            });
                        }, (error) => {
                            console.log('FAILED...', error.text);
                            this.$message({ message: 'Email sending failed', type: 'error' });
                        });
                    } else {
                        this.$message({ message: 'Password reset successful', type: 'success' });
                    }
                } else {
                    this.$message({ message: res.message || 'Failed to reset password', type: 'error' });
                }
            } catch(error) {
                console.log('error:', error);
                this.$message({ message: 'System error, please try again later', type: 'error' });
            }
        },

        // 登录成功
        async _loginSuccessCallback(data, back) {
            window.localStorage.setItem('login@token', data.token)
            document.cookie = 'PHPSESSID=' + data.token
            window.localStorage.setItem('user_id', data.user_id)
            this.getUserInfo()
            window.location.hash = '/'
        },

        async _loginFB(fdata) {
            let  res = await this.$http.get('/login/facebooklogin',fdata)
            
            console.log('email res',res );
            
            if (res.code !== 0) return this.$message.error(res.message)

            console.log('login sucess')
            console.log(res.data)
            this._loginSuccessCallback(res.data, true)
        },

        //获取用户信息
        async getUserInfo(e) {
            const user_id = window.localStorage.getItem('user_id') || ''
            let res = null
            if(user_id){
                res = await this.$http.get('/user/profile',{user_id})
            }
            user_id && res.code == 0 && this.$store.commit('saveUserInfo',res.data)
        },
		
		 async onSignInSuccess (response) {
		        // FB.api('/me', dude => {
		        //   console.log(Good to see you, ${dude.name}.)
		        // })
				const token = response.authResponse.accessToken
				const userID = response.authResponse.userID
				
		        console.log(response) //返回第三方的登录信息 tolen等
		        console.log('token',token) //返回第三方的登录信息 tolen等
				
				let  fdata= {
						userid: userID
					}
					 
	            let  res = await this.$http.get('/login/facebooklogin',fdata)
				  
				  console.log('email res',res );
				  
				  if (res.code !== 0) return this.$message.error(res.message)

                  console.log('login sucess')
                  console.log(res.data)
				  this._loginSuccessCallback(res.data, true)
				  
				
		},
		// 获取facebook用户信息
		getFacebookUserinfo(params) {
		  return request({
		    url: '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_facebook_info',
		    method: 'get',
		    params
		  })
		},
		onSignInError (error) {
			
		      },

        makeRandomString(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
            }
            return result;
        }
    }
}
</script>
<style lang="scss" scoped>
.login-wrapper {
    width: 100%;
    height: 100%;
    .top {
        height: 120px;
        background: #fff;
        width: 100%;
        .logo {
            height: 60%;
            img {
                height: 100%;
                width: 320px;
            }
        }
        .right {
            flex: 1;
            .items {
                margin-left: 40px;
                font-size: 16px;
                color: #666;
                .iconfont {
                    color: #e93323 !important;
                    opacity: 0.8;
                }
            }
        }
    }
    .bottom {
        width: 100%;
        height: 608px;
        background: url("~@/assets/images/loginBg.jpg") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .wrapper{
            @media (min-width:320px)  { width: 100%;right: 0px; }
            @media (min-width:481px)  { width: 100%;right: 0px; }
            @media (min-width:641px)  { width: 100%;right: 0px; }
            @media (min-width:961px)  { width: 100%;right: 0px; }
            @media (min-width:1025px) {  width: 550px;right: 360px; }
            @media (min-width:1281px) {  width: 550px;right: 360px; }
            height: 497px;
            background-color: #fff;
            position: absolute;
            top: 91px;
            
            text-align: center;
            padding: 70px 30px;
            box-sizing: border-box;
            .title{
                font-size: 20px;
                font-weight: 400;
                position: relative;
            }
            .input-with-select{
                margin-top: 30px;
            }
            .code{
                margin-top: 30px;
            }
            .signIn{
                width: 100%;
                height: 50px;
                text-align: center;
                line-height: 50px;
                margin: 24px auto 0;
                color: #fff;
                cursor: pointer;
                background: #e93323!important;
            }
            .fastLogin{
                margin-top: 14px;
                cursor: pointer;
                color: #e93323;
            }
        }
    }
}
</style>
<style lang="css" scoped>
    .login-wrapper >>> .el-select .el-input {
        width: 110px;
    }
</style>